<template>
  <div class="agent-table-wrapper">
    <div class="tab-content">
      <div class="tab-sec" ref="tabSec">
        <div class="tab-sec-list" ref="tabSecList">
          <div class="input-group input-search-fuzzy" v-if="false">
            <input
              v-model="agentSearch"
              class="inputbox"
              type="text"
              placeholder="请输入坐席名称"
              style="width: 160px; margin-right: 5px"
            />
            <el-tooltip effect="light" content="搜索" placement="top">
              <svg class="icon icon-search" aria-hidden="true">
                <use xlink:href="#iconsearchicon" />
              </svg>
            </el-tooltip>
          </div>
          <el-form label-width="60px" style="width: 220px; float: left">
            <AgentStructure
              :getAgentData="getAgentData"
              :showSkillGrouop="false"
              :showAgent="false"
            ></AgentStructure>
            <!-- <el-button type="primary" size="small" @click="getAllAgentInfo()">搜索</el-button> -->
          </el-form>
          <el-button
            style="float: left; margin: 4px"
            type="primary"
            size="small"
            @click="getAllAgentInfo()"
            >搜索</el-button
          >
        </div>
        <el-table
          :data="agentDataShow"
          highlight-current-row
          style="width: 319px"
          :max-height="tableMaxHeight"
          @row-click="agentRowClick"
        >
          <el-table-column
            align="center"
            header-align="center"
            prop="agent.agentData.realName"
            label="坐席名称"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="sessNum"
            label="正在会话"
          >
          </el-table-column>
          <el-table-column
            align="center"
            header-align="center"
            prop="agent.status"
            :formatter="formatType"
            label="状态"
          >
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div
      class="queuing-libox"
      style="left: 320px; width: 750px; overflow-y: auto"
      v-show="showAgentSessionInfo"
    >
      <div class="queuing-liboxtitle clearfix">
        <div class="pull-left">
          {{ current_agent.nickname }}-正在接待会话列表
        </div>
        <div class="pull-right">
          <a href="javaScript:;">
            <el-tooltip content="关闭" placement="top">
              <svg
                class="icon icon-search"
                aria-hidden="true"
                @click="hideAgentSessionInfo()"
              >
                <use xlink:href="#iconguanbi" />
              </svg>
            </el-tooltip>
          </a>
        </div>
      </div>
      <div class="queuing-liboxtool" style="32px">
        <div class="pull-left">
          <div class="input-group input-search-fuzzy">
            <input
              v-model="sessionInfoSearch"
              class="inputbox"
              type="text"
              placeholder="请输入业务名称/访客ID/访客名称/终端"
              style="width: 290px"
            />
            <svg class="icon icon-search" aria-hidden="true">
              <use xlink:href="#iconsearchicon" />
            </svg>
          </div>
          <el-button
            type="primary"
            style="margin-left: 10px"
            size="small"
            @click="getAgentSessionInfo(current_agent.id)"
            >刷新会话列表</el-button
          >
        </div>
      </div>
      <el-table :data="sessionDataShow" style="width: 100%">
        <el-table-column
          label="序号"
          align="center"
          header-align="center"
          type="index"
          width="50"
        >
        </el-table-column>
        <el-table-column
          label="访客"
          prop="userName"
          align="center"
          header-align="center"
        >
        </el-table-column>
        <el-table-column
          label="会话时长"
          prop="sessTime"
          align="center"
          header-align="center"
        >
          <template slot-scope="props">
            {{
              props.row.sessTime
                .substring(props.row.sessTime.indexOf("h") + 1)
                .replace("m", ":")
                .replace("s", "")
            }}
          </template>
        </el-table-column>
        <el-table-column
          label="进线业务"
          prop="bizName"
          align="center"
          header-align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.bizName ? scope.row.bizName : "-" }}
          </template>
        </el-table-column>
        <el-table-column
          label="终端渠道"
          prop="channelName"
          align="center"
          header-align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.channelName ? scope.row.channelName : "-" }}
          </template>
        </el-table-column>
        <el-table-column
          label="监控状态"
          prop="watched"
          align="center"
          header-align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.watched ? "监控中" : "未监控" }}
          </template>
        </el-table-column>
        <el-table-column
          label="参与状态"
          prop="joined"
          align="center"
          header-align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.joined ? "参与中" : "未参与" }}
          </template>
        </el-table-column>
        <el-table-column label="操作" prop="desc" align="center">
          <template slot-scope="scope">
            <el-tooltip
              class="item"
              effect="light"
              content="查看"
              placement="bottom"
            >
              <el-button
                type="text"
                @click="watchSession(scope.$index, scope.row)"
                v-show="!scope.row.joined && !scope.row.watched"
              >
                <svg class="icon" aria-hidden="true">
                  <use xlink:href="#iconxiangqing" />
                </svg>
              </el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
      <div class="clearfix"></div>
    </div>
    <div
      class="queuing-liboxbg"
      style="left: 350px"
      v-show="showAgentSessionInfo"
    ></div>
  </div>
</template>

<script>
import AgentStructure from '@/views/workreport/components/public/AgentStructure';
import { mapState } from 'vuex';
export default {
  name: 'AgentTable',
  data() {
    return {
      agentSearch: '',
      sessionInfoSearch: '',
      agentData: [],
      sessionData: [],
      showAgentSessionInfo: false,
      current_agent: Object,
      userGroupIds: [],
      tableMaxHeight: 0
    };
  },
  props: {
    curSessionId: String
  },
  components: { AgentStructure },
  computed: {
    ...mapState(['user']),

    agentDataShow() {
      // 动态过滤坐席列表
      const searchText = this.agentSearch;
      if (searchText) {
        return this.agentData.filter(function (item) {
          return Object.keys(item.agent.agentData).some(function (key) {
            return (
              key === 'realName' &&
              String(item.agent.agentData[key]).indexOf(searchText) > -1
            );
          });
        });
      } else {
        return this.agentData;
      }
    },
    sessionDataShow() {
      // 动态过滤坐席会话信息列表
      const searchText = this.sessionInfoSearch;
      if (searchText) {
        return this.sessionData.filter(function (item) {
          return Object.keys(item).some(function (key) {
            return (
              (key === 'bizName' ||
                key === 'userId' ||
                key === 'userName' ||
                key === 'channelName') &&
              String(item[key]).indexOf(searchText) > -1
            );
          });
        });
      } else {
        return this.sessionData;
      }
    }
  },
  mounted() {
    this.userGroupIds = [];
    this.getAllAgentInfo();

    this.$nextTick(() => {
      this.tableMaxHeight =
        this.$refs.tabSec.getBoundingClientRect().height -
        this.$refs.tabSecList.getBoundingClientRect().height;
    });
  },
  methods: {
    getAgentData(data) {
      console.log(data.agentGroupIds);
      this.userGroupIds = data.agentGroupIds;
    },
    // 获取所有在线坐席信息
    getAllAgentInfo() {
      const params = {
        userGroupIds: this.userGroupIds
      };
      this.$http
        .post(
          window.$envUtils('VUE_APP_WB_SERVICE') + '/infinite/watch/allAgent',
          { data: params.userGroupIds }
        )
        .then((res) => {
          this.agentData = res.data.data;
          console.log(this.agentData);
        });
    },
    // 获取所有坐席会话信息
    getAgentSessionInfo(agentId) {
      this.$http
        .get(
          window.$envUtils('VUE_APP_WB_SERVICE') +
            '/infinite/watch/allAgentSessionInfo/' +
            agentId
        )
        .then((res) => {
          this.sessionData = res.data.data;
        });
    },
    // 坐席列表行点击
    agentRowClick(row, column, event) {
      this.current_agent = row.agent;
      const agentId = row.agent.id;
      this.getAgentSessionInfo(agentId);
      this.showAgentSessionInfo = true;
    },
    // 监控会话
    watchSession(index, row) {
      this.$parent.getSessionInfo({
        sessionId: row.sessionId,
        userId: row.userId,
        agentId: row.agentId
      });
      this.showAgentSessionInfo = false;
    },
    // 关闭坐席会话信息窗口
    hideAgentSessionInfo() {
      this.showAgentSessionInfo = false;
    },
    // 格式化坐席状态
    formatType(row, column, cellValue, index) {
      if (cellValue === 1) {
        return '空闲';
      } else if (cellValue === 2) {
        return '忙碌';
      } else {
        return '离开';
      }
    }
  }
};
</script>
<style scoped lang="scss">
.agent-table-wrapper {
  height: calc(100% - 51px);
  overflow: hidden;
  display: flex;
}
</style>
